import { render, staticRenderFns } from "./MessageTypeSystemForward.vue?vue&type=template&id=65a32748&scoped=true&"
import script from "./MessageTypeSystemForward.vue?vue&type=script&lang=js&"
export * from "./MessageTypeSystemForward.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeSystemForward.vue?vue&type=style&index=0&id=65a32748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a32748",
  null
  
)

export default component.exports